import { Controller } from "@hotwired/stimulus"
import Handlebars from "handlebars"
import BaseGrid, { html } from "../utils/base_grid"

// Pre-compile templates
const statusBadgeTemplate = Handlebars.compile(`
  {{#if isRevoked}}
    <span class="badge badge-danger">Revoked</span>
  {{else}}
    {{#if isExpired}}
      <span class="badge badge-warning">Expired</span>
    {{else}}
      <span class="badge badge-success">Active</span>
    {{/if}}
  {{/if}}
`)

const actionButtonsTemplate = Handlebars.compile(`
  <div class="btn-group">
    <a href="{{regenerateUrl}}" class="btn btn-sm btn-secondary" data-turbo-method="post" data-turbo-confirm="This will revoke the current token and create a new one. Continue?">Regenerate</a>
    <a href="{{deleteUrl}}" class="btn btn-sm btn-danger" data-turbo-method="delete" data-turbo-confirm="Are you sure you want to revoke this token?">Revoke</a>
  </div>
`)

export default class extends Controller {
  static values = { url: String }
  static targets = ["container", "skeleton"]

  connect() {
    this.baseGrid = new BaseGrid(this, {
      limit: 10,
      columns: [
        { name: "Name", id: "name" },
        { name: "Created", id: "created_at" },
        { name: "Expires", id: "expires_at" },
        { name: "Last Used", id: "last_used_at" },
        { 
          name: "Status", 
          id: "status",
          formatter: (cell, row) => {
            const isExpired = row.cells[5].data
            const isRevoked = row.cells[6].data
            return html(statusBadgeTemplate({ isExpired, isRevoked }))
          }
        },
        { name: "IsExpired", id: "is_expired", hidden: true },
        { name: "IsRevoked", id: "is_revoked", hidden: true },
        { name: "DeleteURL", id: "delete_url", hidden: true },
        { name: "RegenerateURL", id: "regenerate_url", hidden: true },
        { 
          name: "Actions",
          sort: false,
          formatter: (cell, row) => {
             const deleteUrl = row.cells[7].data
             const regenerateUrl = row.cells[8].data
             return html(actionButtonsTemplate({ deleteUrl, regenerateUrl })) 
          }
        }
      ],
      mapData: (item) => [
        item.name, 
        item.created_at, 
        item.expires_at,
        item.last_used_at,
        null, // Status placeholder
        item.is_expired,
        item.is_revoked,
        item.delete_url,
        item.regenerate_url
      ]
    })
    
    this.grid = this.baseGrid.create()
  }
  
  disconnect() {
    this.baseGrid.destroy()
  }
}
